import ContactModel from "../models/ContactModel";
import ContactApiService from "./ContactApiService";

class ContactService {
  constructor() {
    this.contacts = [];
  }
  async init() {
    this.contacts = await ContactApiService.getContacts();
    this.initializeMockData();
  }

  async getAllContacts() {
    return this.contacts;
  }

  async getContactById(contactId) {
    console.log('this.contact', this.contacts);
    
    return this.contacts.find((contact) => contact.getId() === contactId);
  }

  searchContacts(query) {
    const lowercaseQuery = query.toLowerCase();
    return this.contacts.filter(
      (contact) =>
        contact.name.toLowerCase().includes(lowercaseQuery) ||
        contact.phone.includes(lowercaseQuery) ||
        (contact.email && contact.email.toLowerCase().includes(lowercaseQuery))
    );
  }

  filterContactsByTag(tag) {
    if (!tag || tag === "All") {
      return [...this.contacts];
    }
    return this.contacts.filter((contact) => contact.getTags().getName().includes(tag));
  }

  getAllTags() {
    const allTags = new Set();
    this.contacts.forEach((contact) => {
      contact.getTags().forEach((tag) => allTags.add(tag.getName()));
    });
    return Array.from(allTags).sort();
  }

  async toggleContactSelection(contactId) {
    const contact = await this.getContactById(contactId);
    if (contact) {
      contact.isSelected = !contact.isSelected;
    }
  }

  getSelectedContacts() {
    return this.contacts.filter((contact) => contact.isSelected);
  }

  clearSelection() {
    this.contacts.forEach((contact) => {
      contact.isSelected = false;
    });
  }

  addContact(contactData) {
    const newContact = new ContactModel(
      Date.now(), // Use timestamp as ID
      contactData.name,
      contactData.phone,
      contactData.email,
      contactData.avatar,
      false,
      contactData.tags || []
    );
    this.contacts.push(newContact);
    return newContact;
  }

  async updateContacts(contactId, contactData) {
    const contact = await this.getContactById(contactId);
    if (contact) {
      Object.assign(contact, contactData);
    }
    return contact;
  }

  deleteContacts(contactId) {
    const index = this.contacts.findIndex(
      (contact) => contact.id === contactId
    );
    if (index !== -1) {
      this.contacts.splice(index, 1);
      return true;
    }
    return false;
  }
}

export default ContactService;
